import React from 'react';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {
  AttachmentVisualContentTypesEnum,
  parseVisualContentType,
  RemoteAttachmentModel,
} from '../../../libs/shared/core/src/models/api/attachmentModel';
import {reportToBugsnag} from '../../../libs/shared/core/src/services/bugsnag/bugsnag';

// Text used to identify the source of a remote attachment.
const googleDriveText = 'Google Drive';
const dropboxText = 'Dropbox';

const googleUrl = 'google.com';
const googleDriveUrl = 'drive.google.com';
const dropboxUrl = 'dropbox.com';

export const computeRemoteAttachmentSourceName = (attachment: RemoteAttachmentModel) => {
  try {
    const remoteUrl = new URL(attachment.remotePath);
    if (
      remoteUrl.hostname.includes(googleDriveUrl) ||
      (remoteUrl.hostname.includes(googleUrl) &&
        parseVisualContentType(attachment.remoteMimeType) !== AttachmentVisualContentTypesEnum.GENERIC)
    ) {
      return googleDriveText;
    }
    if (remoteUrl.hostname.includes(dropboxUrl)) {
      return dropboxText;
    }
    return <Trans id="remote-attachment-source-other">Other</Trans>;
  } catch {
    reportToBugsnag(new Error('Calendar remote attachment remotePath could not be parsed as URL'));
    return null;
  }
};
